import { AxiosInstance } from "axios";

const materialServices = (instance: AxiosInstance) => {
  const list = (id_tipo_usuario) =>
    instance
      .get(
        `/material?include=tipoBase,subProducto,tipoMaterial&perPage=100000&id_tipo_usuario=${id_tipo_usuario}`
      )
      .then((response: any) => {
        const { data, ...rest } = response.data.result;
        return [data, rest];
      });
  const all = () =>
    instance
      .get(`/material?include=tipoBase,subProducto,tipoMaterial&perPage=100000`)
      .then((response: any) => {
        const { data, ...rest } = response.data.result;
        return [data, rest];
      });
  const listBases = (subProducto, tipoBase, id_tipo_usuario) =>
    instance
      .get(
        `/material?include=tipoBase,subProducto,tipoMaterial&id_tipo_material=1&id_tipo_subproducto=${subProducto}&id_tipo_base=${tipoBase}&perPage=100000&id_tipo_usuario=${id_tipo_usuario}`
      )
      .then((response: any) => {
        const { data, ...rest } = response.data.result;
        return [data, rest];
      });
  const listPigmentos = (id_tipo_usuario) =>
    instance
      .get(
        `/material?include=tipoBase,subProducto,tipoMaterial&id_tipo_material=2&perPage=100000&id_tipo_usuario=${id_tipo_usuario}`
      )
      .then((response: any) => {
        const { data, ...rest } = response.data.result;
        return [data, rest];
      });
  const update = (id, values) => instance.put("/material/" + id, values);
  const del = (id) => instance.delete("/material/" + id);
  const show = (id) =>
    instance.get("/material/" + id).then((response: any) => {
      const { result, ...rest } = response.data;
      return [result, rest];
    });
  const create = (values) => instance.post("/material", values);
  const listAllBasesByUser = (id_tipo_usuario) =>
    instance
      .get(
        `/material?include=tipoBase,subProducto,tipoMaterial&id_tipo_material=1&perPage=100000&id_tipo_usuario=${id_tipo_usuario}`
      )
      .then((response: any) => {
        const { data, ...rest } = response.data.result;
        return [data, rest];
      });

  return {
    list,
    update,
    del,
    show,
    create,
    listPigmentos,
    listBases,
    all,
    listAllBasesByUser,
  };
};
export default materialServices;
